import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CourseIconMappingService } from '../../services/course-icon-mapping.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { LearningPlanBuilderDataService } from '../../../domains/academy/learning-plan/services/learning-plan-builder-data.service';
import { MatDialog } from '@angular/material/dialog';
import { CourseService } from '../../../domains/academy/course/services/course.service';
import { CourseDetailCardComponent } from '../../../domains/academy/course/components/course-detail-card/course-detail-card.component';

import { LinkComponent } from '../link/link.component';
import { DIALOG_SIZE_LARGE } from '../dialog/dialog-sizes';

@Component({
  selector: 'app-course-card',
  imports: [MatIcon, TranslocoPipe, LinkComponent],
  templateUrl: './course-card.component.html',
})
export class CourseCardComponent {
  @Input() name: string;
  @Input() courseId: string;
  @Input() isEditable = true;
  @Output() removeCourseButtonClickedEvent: EventEmitter<void> =
    new EventEmitter<void>();

  private readonly courseIconMappingService = inject(CourseIconMappingService);
  private readonly courseService = inject(CourseService);
  private readonly dialog = inject(MatDialog);
  readonly dataService = inject(LearningPlanBuilderDataService);

  onButtonClick() {
    this.removeCourseButtonClickedEvent.emit();
  }

  onOpenCourseDetailCard(): void {
    if (!this.courseId) {
      return;
    }

    this.courseService.getCourseById(this.courseId).subscribe((course) => {
      if (course.isLocked) {
        return;
      }

      this.dialog.open(CourseDetailCardComponent, {
        autoFocus: false,
        ...DIALOG_SIZE_LARGE,
        data: {
          course,
          isPrecuratedTraining: true,
        },
      });
    });
  }

  getCourseIcon(): string {
    const topicAreaId =
      this.dataService.formGroupSettings.controls.topicAreaId.value;
    return this.courseIconMappingService.getCourseIcon(
      this.name,
      topicAreaId ?? '',
    );
  }

  getTopicAreaName(): string {
    const topicAreaId =
      this.dataService.formGroupSettings.controls.topicAreaId.value;
    const topicArea = this.dataService.topicAreas.find(
      (area) => area.value === topicAreaId,
    );
    return topicArea?.key ?? '';
  }
}
